export default __webpack_public_path__ + "media/examples/static-f6ef77a1.jpg";